<template>
    <button @click="handleClick" :aria-label="label" class="button app-navigation-button app-phone-full-width app-print-hide" :class="{ 'app-button-primary': isPrimary }">
        <i style="justify-self: flex-start;" v-if="iconClass" :class="'dm-pointer ' + iconClass " :alt="label"> </i>
        <span style="justify-self: flex-end;">{{ label }}</span>
    </button>
</template>

<script>
export default {
    name: 'menu-button',
    props: {
        label: String,
        iconClass: String,
        isPrimary: Boolean
    },
    data() {
        return {};
    },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
}
</script>

<style scoped>
    .button {
        height: 40px;
        padding: 10px 16px 10px 16px;
        background-color: #F6F6F7;
        border-radius: 14px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        gap: 8px;
        text-wrap-mode: nowrap;
    }

    .icon {
        margin-right: 3px
    }
    

    .app-button-primary {
        background-color: #C2E66E;
    }

    @media (max-width: 576px) {
        .button {
            display: flex;
            flex-direction: row;
        }
    }
</style>